import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getPartners, getLoading } from './redux/selectors';
import { get_partners } from './redux/reducer';

import chevronLeft from '@design-system/Assets/chevLeft.svg';
import chevronRight from '@design-system/Assets/chevRight.svg';

import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Footer from './components/Footer';
import Header from './components/Header';

export default function MarketPlace() {
  const partners = useSelector(getPartners);
  const loading = useSelector(getLoading);
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  useEffect(() => {
    const storedPage = sessionStorage.getItem('currentPage');

    if (!partners.length) {
      dispatch(get_partners({ page: 1, limit: 1000, searchString: '' }));
    } else if (storedPage) {
      const filteredPartners = partners.filter((partner) => partner.products > 0);
      const totalPages = Math.ceil(filteredPartners.length / itemsPerPage);
      const initialPage = storedPage ? Number(storedPage) : 1;

      if (initialPage >= 1 && initialPage <= totalPages) {
        setCurrentPage(initialPage);
      }
    }
  }, [dispatch, partners]);

  const filteredPartners = partners.filter((partner) => partner.products > 0);
  const totalPages = Math.ceil(filteredPartners.length / itemsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      sessionStorage.setItem('currentPage', newPage.toString());
      setCurrentPage(newPage);
    }
  };

  const handleNextPage = () => {
    handlePageChange(currentPage + 1);
  };

  const handlePrevPage = () => {
    handlePageChange(currentPage - 1);
  };

  const generatePageButtons = () => {
    const buttons = [];
    const numButtons = 3;

    for (let i = currentPage; i < currentPage + numButtons; i++) {
      if (i <= totalPages) {
        buttons.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            className={`${
              i === currentPage ? 'bg-ak100 text-white' : 'border border-ak100'
            } px-3 py-1  text-sm font-bold`}
          >
            {i}
          </button>,
        );
      }
    }

    return buttons;
  };

  const renderLoadingSkeletons = () => {
    const skeletons = [];
    const numSkeletons = itemsPerPage;

    for (let i = 0; i < numSkeletons; i++) {
      skeletons.push(
        <div key={i} className="mb-10 w-full animate-pulse ">
          <div className="h-40 md:h-48 lg:h-64 bg-ak50 justify-center items-center"></div>
          <div className="bg-gray-300 font-bold py-6  bg-ak100 text-center w-full block py-3  "></div>
        </div>,
      );
    }

    return skeletons;
  };

  return (
    <div>
      <Header active="marketplace" />
      <main className="">
        <div className="flex flex-col items-center justify-center pt-36 pb-32 md:pb-48 bg-mlanding bg-cover ">
          <h2 className="text-2xl md:text-4xl lg:text-6xl lg:w-9/12 text-center font-bold text-white">
            Find African Food <br /> and Grocery vendors near you
          </h2>
          <p className="lg:w-7/12 md:tex-lg md:w-3/5 lg:text-xl font-light text-center mt-4 text-white">
            Our marketplace powered by AI technology streamlines the process of
            ‘market runs’ by digitalizing it.
          </p>
        </div>
        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-6 gap-6 md:gap-8 lg:gap-12 px-4 md:px-8 lg:px-16 mt-14">
            {renderLoadingSkeletons()}
          </div>
        ) : (
          <section className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-6 gap-6 md:gap-8 lg:gap-12 px-4 md:px-8 lg:px-16 mt-14">
            {partners
              .filter((partner) => partner.products > 0)
              .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
              .map((partner, index) => (
                <div key={index} className="mb-10 w-full">
                  {partner?.user?.photo_url ? (
                    <img
                      src={partner?.user?.photo_url}
                      alt="partner image"
                      className="h-40 md:h-48 lg:h-64 w-full"
                    />
                  ) : (
                    <p className="text-center bg-ak50 text-ak100 flex items-center text-xl  md:text-3xl lg:text-4xl  font-ephesis justify-center  h-40 md:h-48 lg:h-64">
                      {partner.business_name}
                    </p>
                  )}

                  <div className="my-5">
                    <h4>{partner.business_name}</h4>
                    <p>{partner.category}</p>
                  </div>
                  <Link
                    to={`/sella/${partner?.business_name}`}
                    className="bg-ak100 font-bold text-white text-center w-full block py-3"
                  >
                    Shop now
                  </Link>
                </div>
              ))}
          </section>
        )}
        {!loading && (
          <div className="flex justify-center my-20">
            <div className="flex gap-4">
              <button
                onClick={handlePrevPage}
                disabled={currentPage === 1}
                className="border border-ak100 px-3 py-1"
              >
                <img src={chevronLeft} />
              </button>
              {generatePageButtons()}
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
                className="border border-ak100 px-3 py-1"
              >
                <img src={chevronRight} />
              </button>
            </div>
          </div>
        )}
      </main>
      {!loading && <Footer />}
    </div>
  );
}
